import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../assets/css/common.css';
import { documentService } from '../services/documentService';

function formatDateTime(value) {
  if (!value) return '-';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '-';
  return `${d.getFullYear()}/${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')} ` +
    `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}

function DocumentList() {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const data = await documentService.getDocuments();
        setDocuments(data.documents || []);
      } catch (err) {
        setError('書面一覧の取得に失敗しました。時間をおいて再度お試しください。');
      } finally {
        setLoading(false);
      }
    };
    fetchDocuments();
  }, []);

  return (
    <div className="container" style={{ maxWidth: 1000, margin: '0 auto', padding: 24 }}>
      <h1 className="text-primary text-center mb-4">書面管理</h1>

      {error && <div className="alert alert-danger">{error}</div>}

      {loading ? (
        <p className="text-muted">読み込み中...</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>書面</th>
              <th>現行バージョン</th>
              <th>公開日時</th>
              <th>改訂内容</th>
              <th>現行版に署名済み</th>
              <th>要再署名</th>
              <th>旧版のまま</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {documents.map((doc) => (
              <tr key={doc.docKey}>
                <td>{doc.title}</td>
                <td>{doc.currentVersion ? `v${doc.currentVersion}` : '未公開'}</td>
                <td>{formatDateTime(doc.publishedAt)}</td>
                <td>{doc.changeNote || '-'}</td>
                <td>{doc.signedCurrent}名</td>
                <td>
                  {doc.needsResign > 0
                    ? <span style={{ color: '#d97706', fontWeight: 'bold' }}>{doc.needsResign}名</span>
                    : <span className="text-muted">0名</span>}
                </td>
                <td>
                  {doc.outdated > 0
                    ? <span>{doc.outdated}名</span>
                    : <span className="text-muted">0名</span>}
                </td>
                <td>
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={() => navigate(`/admin/documents/${doc.docKey}`)}
                  >
                    プレビュー・改訂
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <div className="text-muted text-small mt-3">
        <div>※「要再署名」は、再署名を求める改訂に未対応のメンバー数です。本人にお知らせが表示されます。</div>
        <div>
          ※「旧版のまま」は、現行バージョン以外の版に署名しているメンバー数です。
          再署名を求めずに公開した改訂の場合はここだけが増え、本人へのお知らせは出ません（必要に応じて個別にご連絡ください）。
        </div>
      </div>

      <div className="mt-4">
        <Link to="/" className="btn btn-secondary">マイページに戻る</Link>
      </div>
    </div>
  );
}

export default DocumentList;
